import { ElectricityPackageEarlyTerminationFeeType } from "components/ElectricityPackages/models";
import { isNotNullOrUndefined, isNullOrUndefined } from "./data-util";

export const validateEarlyTermination = (
    earlyTerminationFeeType?: ElectricityPackageEarlyTerminationFeeType,
    earlyTerminationFee?: number,
    twoTariffPackage?: boolean,
    estimatedConsumptionVolumeMwh?: number,
    estimatedConsumptionDayVolumeMwh?: number,
    estimatedConsumptionNightVolumeMwh?: number,
): boolean => {
    if (!earlyTerminationFeeType) return true;
    if (isNullOrUndefined(earlyTerminationFee)) return false;
    if (earlyTerminationFeeType === ElectricityPackageEarlyTerminationFeeType.FIXED_PER_LEFTOVER_MONTH) return true;

    if (twoTariffPackage) {
        return (
            isNotNullOrUndefined(estimatedConsumptionDayVolumeMwh) &&
            isNotNullOrUndefined(estimatedConsumptionNightVolumeMwh)
        );
    }

    return isNotNullOrUndefined(estimatedConsumptionVolumeMwh);
};